import { ReactNode } from "react";
import { createPortal } from "react-dom";
import { DismissableLayerBranch } from "@radix-ui/react-dismissable-layer";

interface DatePickerPopperContainerProps {
  children: ReactNode[];
}

export const DatePickerPopperContainer = ({ children }: DatePickerPopperContainerProps) => {
  if (typeof document === "undefined") {
    return <>{children}</>;
  }

  return createPortal(
    <DismissableLayerBranch className="pointer-events-auto">{children}</DismissableLayerBranch>,
    document.body
  );
};
